import { render } from "./udf.vue?vue&type=template&id=b551f2ba&scoped=true"
import script from "./udf.vue?vue&type=script&lang=js"
export * from "./udf.vue?vue&type=script&lang=js"

import "./udf.vue?vue&type=style&index=0&id=b551f2ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b551f2ba"]])

export default __exports__